import React, { useEffect, useLayoutEffect, useRef, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import "./kitchen.css"
import Lottie from "lottie-react";
import empotyLottie from "../../Assets/lottieFiles/emptybox.json"
import vegIcon from "../../Assets/Images/vegpngoutput.png"
import TicketCalender from '../../Components/calender/TicketCalender';
import Kitchen_ticket from '../../Components/kichen_tickct/kitchen_ticket'
import p_nav_previous from "../../Assets/Images/p_nav_previous.svg";

import ReactLoading from "react-loading";
import moment from 'moment';
import NodeaxiosInstance from '../../Services/nodeaxios';
import { IoIosArrowUp } from "react-icons/io";
import { IoChevronDown } from "react-icons/io5";
import { RxHamburgerMenu } from "react-icons/rx";
import store_icon from "../../Assets/Images/icons/store_icon.png"
import { useSelector } from 'react-redux';
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import KitchenProductTicket from '../../Components/kichen_tickct/kitchenProductTicket';
import KitchenComboTicket from '../../Components/kichen_tickct/kitchenComboTicket';
import "../../Components/kichen_tickct/styles/kitchencomboCard.css";
import KitchenMembershiplistCard from '../../Components/KitchenMembershipCard/KitchenMembershiplistCard';
import { showToast } from '../../Components/toastConfig/ToastConfig';


const Kitchen_ticket_list = () => {
    const navigate = useNavigate();
    const location = useLocation()
    const vendorId = useParams()
    const state = useSelector((state) => state);
    const [userData, serUserData] = useState(state?.userAuth?.user);
    const headerRef = useRef(null);
    const scrollContainerRef = useRef(null);

    const { type } = location.state || {};
    const [data, setData] = useState('')
    const [tickets, setTickets] = useState([])
    const [memberShips, setMemberShips] = useState([])
    const [allTabList, setAllTabLIst] = useState([])

    const [screen, setScreen] = useState('list_screen')
    const [pageLoaded, setPageLoaded] = useState(false)
    const [isMenuOpen, setMenuOpen] = useState(true);
    const [showMenus, setShowMenus] = useState(false);
    const filterStorageKey = `kitchen_list_filters_${vendorId?.vendor_id}`;
    const savedFilters = (() => {
        try {
            const parsed = JSON.parse(sessionStorage.getItem(filterStorageKey) || 'null');
            if (!parsed) return null;
            const savedDate = parsed.paramDate ? new Date(parsed.paramDate) : null;
            const startOfToday = new Date();
            startOfToday.setHours(0, 0, 0, 0);
            // drop a stored date that is invalid or already in the past
            if (!savedDate || isNaN(savedDate.getTime()) || savedDate < startOfToday) parsed.paramDate = '';
            return parsed;
        } catch (e) {
            return null;
        }
    })();
    // subcategory (ticket_category_id) picked in the Menu; filters that meal's tickets
    const [subFilter, setSubFilter] = useState(null)
    // sub categories are open by default; this holds the meal categories collapsed in the Menu
    const [menuCollapsed, setMenuCollapsed] = useState([])
    const [ticketType, setTicketType] = useState(savedFilters?.ticketType ?? 0)
    const [paramDate, setParamDate] = useState(savedFilters?.paramDate || '')
    let valueParam = useParams();
    const [isVegSelected, setIsVegSelected] = useState(savedFilters?.isVegSelected ?? false);
    let headers = { Authorization: userData?.token };
    let finalDate = ''
    const today = moment().format("D MMMM YYYY");


    const handleVegToggle = () => {
        setIsVegSelected(prev => !prev);
        // getFilteredTicketDetails(paramDate)
    };


    // const getFilteredTicketDetails = async (formattedDate) => {
    //     try {
    //         setPageLoaded(false);

    //         if (!formattedDate) {
    //             setTickets([]);
    //             setData('');
    //             setScreen("list_screen");
    //             return;
    //         }

    //         const headers = { Authorization: userData?.token };
    //         let localpreviesdate = localStorage.getItem('previesdate') ? JSON.parse(localStorage.getItem('previesdate')) : '';

    //         finalDate = localpreviesdate
    //             ? moment(localpreviesdate, ["DD-MM-YYYY", "D MMMM YYYY"]).toDate().toDateString()
    //             : moment(formattedDate, ["DD-MM-YYYY", "D MMMM YYYY"]).toDate().toDateString();

    //         setParamDate(formattedDate || finalDate);

    //         setTickets([]);
    //         const res = await NodeaxiosInstance.get('/kitchen/fetch-food-tickets', {
    //             params: {
    //                 vendor_id: valueParam.vendor_id,
    //                 date: finalDate,
    //                 type: ticketType,
    //                 veg_only: isVegSelected ? 1 : 0
    //             },
    //             headers
    //         });
    //         const uniqueTickets = Array.from(
    //             new Map(res.data.result.map(item => [item.id, item])).values()
    //         );

    //         setTickets(uniqueTickets);
    //         setData(res.data);
    //         setScreen("list_screen");


    //     } catch (err) {
    //         const errorMsg = err.response?.data?.message || "Something went wrong";
    //         // showToast(errorMsg) 
    //     } finally {
    //         setPageLoaded(true);
    //     }
    // };

    // must be a ref: a plain `let` is reset on every render, so stale/overlapping requests were never detected
    const requestIdRef = useRef(0);

    // const getFilteredTicketDetails = async (formattedDate) => {
    //     const currentRequest = ++requestId;

    //     try {
    //         setPageLoaded(false);

    //         if (!formattedDate) {
    //             setTickets([]);
    //             setData('');
    //             setScreen("list_screen");
    //             return;
    //         }


    //         let localpreviesdate = localStorage.getItem('previesdate')
    //             ? JSON.parse(localStorage.getItem('previesdate'))
    //             : ''; 
    //         setParamDate(formattedDate); 
    //         if (ticketType != 0) {
    //             const res = await NodeaxiosInstance.get(`/kitchen/${ticketType == 3 ? 'fetch-membership-tickets-by-date' : 'fetch-food-tickets'}`, {
    //                 params: {
    //                     vendor_id: valueParam.vendor_id,
    //                     date: formattedDate,
    //                     type: ticketType,
    //                     veg_only: isVegSelected ? 1 : 0
    //                 },
    //                 headers
    //             });
    //             console.log('res------------', res?.data);

    //             if (currentRequest != requestId) return;
    //             setTickets(res.data.result);
    //             setData(res.data);
    //             setScreen("list_screen");
    //         } else if (ticketType == 0) {
    //             fetchAndMergeAllTickets()
    //         }

    //     } catch (err) {
    //         const errorMsg = err.response?.data?.message || "Something went wrong";
    //     } finally {
    //         if (currentRequest == requestId) {
    //             setTimeout(() => {
    //                 setPageLoaded(true);
    //             }, 1000);
    //         }
    //     }
    // };

    const formatApiDate = (inputDate) => {
        if (!inputDate) return new Date().toDateString();

        if (inputDate instanceof Date) {
            return !isNaN(inputDate.getTime()) ? inputDate.toDateString() : new Date().toDateString();
        }

        if (moment.isMoment(inputDate)) {
            return inputDate.isValid() ? inputDate.toDate().toDateString() : new Date().toDateString();
        }

        if (typeof inputDate === 'string') {
            const trimmed = inputDate.trim();
            if (!trimmed) return new Date().toDateString();

            const dmyMatch = trimmed.match(/^(\d{1,2})[-/](\d{1,2})[-/](\d{4})$/);
            if (dmyMatch) {
                const day = parseInt(dmyMatch[1], 10);
                const month = parseInt(dmyMatch[2], 10) - 1;
                const year = parseInt(dmyMatch[3], 10);
                const dmyDate = new Date(year, month, day);
                if (!isNaN(dmyDate.getTime())) {
                    return dmyDate.toDateString();
                }
            }

            const nativeDate = new Date(trimmed);
            if (!isNaN(nativeDate.getTime())) {
                return nativeDate.toDateString();
            }

            const parsed = moment(trimmed, ["DD-MM-YYYY", "MM-DD-YYYY", "D MMMM YYYY", "YYYY-MM-DD", "ddd MMM DD YYYY", "MMM DD YYYY"]);
            if (parsed.isValid()) {
                return parsed.toDate().toDateString();
            }

            const genericParsed = moment(trimmed);
            if (genericParsed.isValid()) {
                return genericParsed.toDate().toDateString();
            }
        }

        return new Date().toDateString();
    };

    const getFilteredTicketDetails = async (formattedDate) => {
        const currentRequest = ++requestIdRef.current;

        try {
            setPageLoaded(false);

            const effectiveDate = formattedDate || paramDate || today;
            const apiDate = formatApiDate(effectiveDate);

            setParamDate(apiDate);

            const params = {
                vendor_id: valueParam.vendor_id,
                date: apiDate,
                veg_only: isVegSelected ? 1 : 0
            };

            console.log("params ", params);
            if (Number(ticketType) == 0) {
                await fetchAndMergeAllTickets(apiDate, currentRequest);
            } else if (Number(ticketType) == 1 || Number(ticketType) == 2) {
                const res = await NodeaxiosInstance.get('/kitchen/fetch-food-tickets', {
                    params: { ...params, type: Number(ticketType) },
                    headers
                });

                if (currentRequest !== requestIdRef.current) return;

                const result = res?.data?.result ?? [];
                setTickets(result);
                setData(res?.data);
                setScreen("list_screen");
            } else if (Number(ticketType) == 3) {
                const res = await NodeaxiosInstance.get('/kitchen/fetch-membership-tickets-by-date', {
                    params,
                    headers
                });

                if (currentRequest !== requestIdRef.current) return;

                const result = res?.data?.result ?? [];
                setTickets(result);
                setData(res?.data);
                setScreen("list_screen");
            }

        } catch (err) {
            console.error(err);
            const errorMsg = err.response?.data?.message || " Something went wrong. Please try again later.";
            showToast(errorMsg);
        } finally {
            // only the latest request may end the loading state; the timeout re-checks in case a newer one started meanwhile
            if (currentRequest === requestIdRef.current) {
                setTimeout(() => {
                    if (currentRequest === requestIdRef.current) setPageLoaded(true);
                }, 500);
            }
        }
    };



    const fetchAndMergeAllTickets = async (selectedDateParam, currentRequest) => {
        try {
            setPageLoaded(false);
            const effectiveDate = selectedDateParam || paramDate || today;

            const apiDate = formatApiDate(effectiveDate);

            const params = {
                vendor_id: valueParam.vendor_id,
                date: apiDate,
                veg_only: isVegSelected ? 1 : 0
            };
            console.log("fetchAndMergeAllTickets params ---->", params);

            const [membershipRes, type1Res, type2Res] = await Promise.all([
                NodeaxiosInstance.get('/kitchen/fetch-membership-tickets-by-date', { params, headers }),
                NodeaxiosInstance.get('/kitchen/fetch-food-tickets', { params: { ...params, type: 1 }, headers }),
                NodeaxiosInstance.get('/kitchen/fetch-food-tickets', { params: { ...params, type: 2 }, headers }),
            ]);

            const membershipData = membershipRes?.data?.result ?? [];
            const type1Data = type1Res?.data?.result ?? [];
            const type2Data = type2Res?.data?.result ?? [];

            const mergedMap = {};

            const upsertCategory = (item) => {
                if (!mergedMap[item.category_id]) {
                    mergedMap[item.category_id] = {
                        category_id: item.category_id,
                        category_name: item.category_name,
                        startTime: item.startTime,
                        endTime: item.endTime,
                        membership_tickets: [],
                        como_tickets: [],
                        food_tickets: [],
                        ticket_count: 0,
                    };
                }
            };

            membershipData.forEach((item) => {
                upsertCategory(item);
                mergedMap[item.category_id].membership_tickets.push(...(item.tickets ?? []));
            });

            type2Data.forEach((item) => {
                upsertCategory(item);
                mergedMap[item.category_id].como_tickets.push(...(item.tickets ?? []));
            });

            type1Data.forEach((item) => {
                upsertCategory(item);
                mergedMap[item.category_id].food_tickets.push(...(item.tickets ?? []));
            });

            const mergedResult = Object.values(mergedMap).map((category) => ({
                ...category,
                ticket_count:
                    category.membership_tickets.length +
                    category.como_tickets.length +
                    category.food_tickets.length,
            }));

            // ignore a response that a newer request has already replaced
            if (currentRequest !== undefined && currentRequest !== requestIdRef.current) return;
            setAllTabLIst(mergedResult);
        } catch (error) {
            console.error(error);
            showToast(error?.response?.data?.message ?? 'Something went wrong. Please try again.');
        }
        // loading is ended by getFilteredTicketDetails once the latest request has finished
    };


    const getMembershiptickets = async () => {
        try {

            const reqDate = paramDate || today;
            const res = await NodeaxiosInstance.get('/kitchen/fetch-membership-tickets-by-date', {
                params: {
                    vendor_id: valueParam.vendor_id,
                    date: reqDate,
                    veg_only: isVegSelected ? 1 : 0
                },
                headers
            });
            setMemberShips(res.data.result);
            setPageLoaded(true);

        }
        catch (err) {
            console.error(err);
        }
    }

    // layout effect: the loading flag is raised before the browser paints, so a tab/veg change never
    // flashes the previous list or "No Tickets Available" while the new request is starting
    useLayoutEffect(() => {

        setSubFilter(null)
        getFilteredTicketDetails(paramDate)

    }, [ticketType, isVegSelected])

    // keep the selected tab, date and veg toggle so they survive Buy Now -> back
    useEffect(() => {
        try {
            sessionStorage.setItem(filterStorageKey, JSON.stringify({ ticketType, isVegSelected, paramDate }));
        } catch (e) { }
    }, [ticketType, isVegSelected, paramDate]);

    const clearSavedFilters = () => {
        try { sessionStorage.removeItem(filterStorageKey); } catch (e) { }
    };

    const [calendarKey, setCalendarKey] = useState(0);

    // Jump to the following day: remount the calendar on that date so it reloads the tickets.
    const chooseNextDay = () => {
        const nextDay = moment(paramDate ? new Date(paramDate) : new Date()).add(1, 'day');
        setParamDate(nextDay.toDate().toDateString());
        setCalendarKey((key) => key + 1);
    };

    const renderNoTickets = () => (
        <div className='d-flex flex-column align-items-center text-center pb-5'>
            <div className='w-100'>
                <Lottie animationData={empotyLottie} />
            </div>
            <p className='text-dark mt-3 mb-4 ff-poppins-regular fs-16'>No Tickets Available</p>
            <button type='button' className='btn kitchen-next-day-btn rounded-pill px-5 py-2 ff-poppins-semiBold fs-18' onClick={chooseNextDay}>
                Choose Next Day
            </button>
        </div>
    );

    const [openIndices, setOpenIndices] = useState([0]);
    const isItemOpen = (index) => openIndices.includes(index);

    useEffect(() => {
        if (ticketType != 0) {
            setOpenIndices(tickets?.map((_, index) => index));
        }
        else {
            setOpenIndices(allTabList?.map((_, index) => index));

        }
    }, [allTabList, tickets]);


    const toggleAccordion = (index) => {

        if (openIndices.includes(index)) {
            setOpenIndices(openIndices.filter((i) => i !== index));
        } else {
            setOpenIndices([...openIndices, index]);
        }
    };

    const categoryRefs = useRef({});
    const [openAccordionId, setOpenAccordionId] = useState(null);
    // const handleCategoryClick = (categoryId) => { 
    //     if (categoryRefs.current[categoryId]) {
    //         categoryRefs.current[categoryId].scrollIntoView({
    //             behavior: "smooth",
    //             block: "start",
    //         }); 
    //         setOpenAccordionId(categoryId);
    //     }
    //     setMenuOpen(true)
    //     setShowMenus(false)
    // };

    // Categories currently on screen; the All tab and the other tabs keep them in different lists.
    const menuCategories = ticketType == 0 ? allTabList : tickets;

    // membership cards sit inside each meal category of the All tab; the Menu lists them first
    const membershipMenuCount = ticketType == 0
        ? (allTabList || []).reduce((sum, c) => sum + (c?.membership_tickets?.length || 0), 0)
        : 0;
    const firstMembershipCategory = ticketType == 0 ? (allTabList || []).find((c) => c?.membership_tickets?.length > 0) : null;

    // food and combo tickets of a meal category grouped by ticket_category_id -> [{ id, name, count }]
    // (membership tickets have no ticket category)
    const getSubCategories = (cate) => {
        const list = ticketType == 0
            ? [...(cate?.food_tickets || []), ...(cate?.como_tickets || [])]
            : (ticketType == 1 || ticketType == 2) ? (cate?.tickets || []) : [];
        const groups = new Map();
        list.forEach((t) => {
            const id = t?.ticket_category_id;
            const name = t?.ticket_category_name ? String(t.ticket_category_name).trim() : "";
            if (id === undefined || id === null || id === "" || !name) return;
            const key = String(id);
            if (groups.has(key)) groups.get(key).count += 1;
            else groups.set(key, { id, name, count: 1 });
        });
        return Array.from(groups.values());
    };

    // the Menu scrolls to a sub category instead of filtering, so the lists are shown as they are
    const visibleAllTabList = allTabList;
    const visibleTickets = tickets;

    const handleSelectSub = (categoryId, subId) => {
        setSubFilter({ categoryId, subId });
        const categoryIndex = menuCategories.findIndex((cate) => cate.category_id == categoryId);
        if (categoryIndex !== -1) {
            setOpenIndices((prev) => (prev.includes(categoryIndex) ? prev : [...prev, categoryIndex]));
        }
        setOpenAccordionId(categoryId);
        setMenuOpen(true);
        setShowMenus(false);

        // wait for the accordion to expand, then scroll to the first ticket of that sub category
        setTimeout(() => {
            const container = scrollContainerRef.current;
            const categoryEl = categoryRefs.current[categoryId];
            const element = categoryEl?.querySelector(`[data-sub-id="${String(subId).replace(/"/g, '')}"]`) || categoryEl;
            if (!element) return;

            if (container) {
                const scrollTo = container.scrollTop + (element.getBoundingClientRect().top - container.getBoundingClientRect().top) - 8;
                container.scrollTo({ top: Math.max(scrollTo, 0), behavior: "smooth" });
            } else {
                element.scrollIntoView({ behavior: "smooth", block: "start" });
            }
        }, 350);
    };

    const handleCategoryClick = (categoryId) => {
        const categoryIndex = menuCategories.findIndex((cate) => cate.category_id == categoryId);

        // open the chosen category so its tickets are visible after the jump
        if (categoryIndex !== -1) {
            setOpenIndices((prev) => (prev.includes(categoryIndex) ? prev : [...prev, categoryIndex]));
        }
        setOpenAccordionId(categoryId);
        setMenuOpen(true);
        setShowMenus(false);

        // wait for the accordion to expand before measuring the scroll position
        setTimeout(() => {
            const container = scrollContainerRef.current;
            const element = categoryRefs.current[categoryId];
            if (!element) return;

            if (container) {
                const scrollTo = container.scrollTop + (element.getBoundingClientRect().top - container.getBoundingClientRect().top) - 8;
                container.scrollTo({ top: Math.max(scrollTo, 0), behavior: "smooth" });
            } else {
                element.scrollIntoView({ behavior: "smooth", block: "start" });
            }
        }, 60);
    };


    const dropUpMenuPress = () => {
        setShowMenus((prevShowMenus) => {
            const newState = !prevShowMenus;
            return newState;
        });
    };


    return (
        <div className='bg-white '>
            <div ref={headerRef}>
                <div className="mt-2 p-2 d-none" >
                    <div className="d-flex justify-content-between deleiveryAddress rounded-pill bg-white secondary-text-1 p-1">
                        <input type="text" className="SearchServiceBox ms-2  ff-balooPaaji2-regular rounded-pill fs-14 mt-1" placeholder="Search " />
                    </div>
                </div>
                <div className="d-flex justify-content-between align-items-center p-3 p-navbar bg-white border-bottom">
                    <div className="d-flex align-items-center">
                        {/* <IoArrowBackSharp size={25} className="me-2" onClick={() => navigate(`/vendor/${vendorId.vendor_id}`)} /> */}
                        <img src={p_nav_previous} width={"24px"} height={"16px"} alt="Previous Button" role="button"
                            onClick={() => { clearSavedFilters(); navigate(`/vendor/${vendorId.vendor_id}`) }} />
                        <span className="ff-balooPaaji2-bold fs-20 ms-2 ps-1">Food</span>
                    </div>

                    <div className="d-flex align-items-center goStoreBar" onClick={() => { clearSavedFilters(); navigate(`/vendor/${vendorId.vendor_id}`) }}>
                        <img src={store_icon} height="20" width="20" />
                        <span className="fs-12 ff-poppins-medium ms-1">Go to store</span>
                    </div>
                </div>


                <div className='mt-3'>
                    {/* <div className="d-flex justify-content-between">
                        <div className='d-flex  justify-content-around'>
                            <div className={`food-ticket-type ms-1   ${ticketType == '0' ? 'primary-bg text-white' : 'inactive-ticket-type'} `} onClick={() => setTicketType('0')}>
                                All
                            </div>
                            <div className={`food-ticket-type ms-1 me-1 ${ticketType == '1' ? 'primary-bg text-white' : 'inactive-ticket-type'}`} onClick={() => setTicketType('1')}>
                                <span>Food</span>
                                <span>tickets</span>
                                Food    tickets
                            </div>
                            <div className={`food-ticket-type   ${ticketType == '2' ? 'primary-bg text-white' : 'inactive-ticket-type'}`} onClick={() => setTicketType('2')}>
                                Combo   tickets

                            </div>
                            <div className={`food-ticket-type  ms-1 me-1 ${ticketType == '3' ? 'primary-bg text-white' : 'inactive-ticket-type'}`} onClick={() => setTicketType('3')}>
                                Memberships
                            </div>
                        </div>
                        <div className="veg_icon_box me-3" onClick={handleVegToggle}>
                            <div className="fs-10 ff-poppins-medium text-center">VEG</div>
                            <div className={`kitchen-toggle-switch  mt-1 mb-1 ${isVegSelected ? 'kitchen-toggled veg_Color' : ''}`}>
                                <img src={vegIcon} className="kitchen-toggle-button" alt="toggle button" />
                            </div>
                        </div>
                    </div> */}

                    <div className="d-flex justify-content-between ">

                        <div className="d-flex align-items-center">

                            {/* ALL */}
                            <div
                                className={`food-ticket-type ms-1 ${ticketType == '0' ? 'primary-bg text-white' : 'inactive-ticket-type'}`}
                                onClick={() => setTicketType('0')}
                            >
                                <span>All</span>
                            </div>

                            {/* FOOD */}
                            <div className={`food-ticket-type ms-1 me-1 ${ticketType == '1' ? 'primary-bg text-white' : 'inactive-ticket-type'}`}
                                onClick={() => setTicketType('1')}>
                                <div className="food-ticket-text">
                                    <span>Food</span>
                                    <span>Tickets</span>
                                </div>
                            </div>

                            {/* COMBO */}
                            <div className={`food-ticket-type ${ticketType == '2' ? 'primary-bg text-white' : 'inactive-ticket-type'}`}
                                onClick={() => setTicketType('2')}>
                                <div className="food-ticket-text">
                                    <span>Combo</span>
                                    <span>Tickets</span>
                                </div>
                            </div>

                            {/* MEMBERSHIP */}
                            <div className={`food-ticket-type ms-1 me-1 ${ticketType == '3' ? 'primary-bg text-white' : 'inactive-ticket-type'}`} onClick={() => setTicketType('3')}    >
                                <span>Memberships</span>
                            </div>

                        </div>

                        <div className="veg_icon_box me-1" onClick={handleVegToggle}>
                            <div className="fs-10 ff-poppins-medium text-center">VEG</div>
                            <div className={`kitchen-toggle-switch mt-1 mb-1 ${isVegSelected ? 'kitchen-toggled veg_Color' : ''}`}>
                                <img src={vegIcon} className="kitchen-toggle-button" alt="toggle button" />
                            </div>
                        </div>

                    </div>
                </div>

                <TicketCalender key={calendarKey} initialDate={paramDate ? new Date(paramDate) : null} handleFilteredTicketDate={(formattedDate) => getFilteredTicketDetails(formattedDate)} />
            </div>

            {
                pageLoaded ?
                    <>
                        <div className="offcanvas-parentType3" id="scroll" style={{ paddingBottom: "50%" }}>
                            <div className="doorStepService p-0 position-relative" >
                                <div className="scroller-style-y" ref={scrollContainerRef}>

                                    {/* <div className="accordion margin_bottom_250 ">
                                        {
                                            tickets.length > 0 ?
                                            tickets.map((list, index) => {
                                                return (
                                                    <div key={list.category_id} ref={(el) => (categoryRefs.current[list.category_id] = el)} style={{ scrollMarginTop: "120px" }}
                                                        className={`accordion-item product_list_accordion mt-2 ms-1 me-1 ${openAccordionId == list.category_id ? "open" : ""}`} >
                                                        <h2 className="accordion-header  rounded-3 primary-bg" id={"collapseOne" + list.category_id}>
                                                            <button className={`serviceMenu-but  p-2 m-0 accordion-button ff-poppins-bold fs-16 text-white ${isItemOpen(index) ? "" : "collapsed"
                                                                }`} type="button" onClick={() => toggleAccordion(index)} aria-expanded={isItemOpen(index) ? "true" : "false"}   >
                                                                <p className="m-0"> {list.category_name} </p>
                                                                <p className="m-0">
                                                                    {isItemOpen(index) ? (<IoIosArrowUp style={{ fontSize: 20 }} />) : (<IoChevronDown style={{ fontSize: 20 }} />)}
                                                                </p>
                                                                <style>{`button::after { display: none; position: absolute; content: ''; }`}  </style>
                                                            </button>
                                                        </h2>
                                                        <div className={`accordion-collapse collapse ${isItemOpen(index) ? "show" : ""}`} aria-labelledby={"heading" + index}  >
                                                            {
                                                                ticketType == 1 ?
                                                                    list.tickets.map(item => (
                                                                        <div style={{ margin: ' 20px 10px' }}>

                                                                            <KitchenProductTicket item={item} />
                                                                        </div>
                                                                    ))
                                                                    : ticketType == 2 ?
                                                                        <section className="kitchen-combo-section  ">
                                                                            <div className='kitchen-combo-grid scroller-style-x ' >
                                                                                {list.tickets.map(item => (
                                                                                    <KitchenComboTicket key={item} item={item} />))}
                                                                            </div>
                                                                        </section>
                                                                        : ticketType == 3 ?
                                                                            <section className="kitchen-combo-section  ">
                                                                                <div className='kitchen-combo-grid scroller-style-x ' >
                                                                                    <KitchenMembershipCard item={list} />
                                                                                </div>
                                                                            </section> : ""
                                                            } 
                                                        </div>
                                                    </div>
                                                )
                                            })
                                            :
                                            <>
                                                <div>
                                                    <Lottie animationData={empotyLottie} />
                                                </div>
                                                <p className='text-dark text-center mt-5 ff-balooPaaji2-bold fs-20 '>No Ticket Available</p>
                                            </>
                                        } 

                                        */}

                                    {(tickets.length > 0 || allTabList.length > 0) && isMenuOpen && (
                                        <div className="menu-div kitchen-menu-div">
                                            <div className="left-div"></div>
                                            <div className="right-div">
                                                <div className="dropup-center dropup" style={{ zIndex: 9990 }}>
                                                    <button id="menuButton" className="btn btn-secondary dropdown-toggle menuBtn fs-12 ff-poppins-semiBold" type="button" onClick={dropUpMenuPress} style={{ display: showMenus ? "none" : " ", zIndex: 9999 }} >
                                                        <RxHamburgerMenu className="menuIcon" />
                                                        Menu
                                                    </button>
                                                </div>
                                            </div>
                                            {showMenus && (
                                                <>
                                                    <div className="backdrop" style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0, 0, 0, 0.5)', zIndex: 9996 }} onClick={(e) => { e.stopPropagation(); setShowMenus(false) }}></div>
                                                    <div className="menu-list-container">
                                                        <ul className="dropdown-menu show scroller-style-y rounded-4" style={{ height: "auto", minHeight: "260px", maxHeight: "60vh" }} id="menuList"  >
                                                            {membershipMenuCount > 0 && (
                                                                <li className="fs-12 ff-poppins-regular" style={{ borderBottom: "1px solid rgba(255,255,255,0.15)" }}>
                                                                    <div className="d-flex justify-content-between align-items-center p-1">
                                                                        <button className="dropdown-item d-flex collapsed justify-content-between align-items-center"
                                                                            style={{ background: "transparent", color: "#fff", boxShadow: "none", outline: "none", textAlign: "left", justifyContent: "flex-start", flex: 1 }}
                                                                            onClick={() => handleCategoryClick(firstMembershipCategory.category_id)}>
                                                                            <span className="truncate-text">Membership</span>
                                                                        </button>
                                                                        <span className="me-1 text-light d-flex align-items-center" role="button" onClick={() => handleCategoryClick(firstMembershipCategory.category_id)}>
                                                                            <span style={{ background: "rgba(255,255,255,0.18)", borderRadius: 8, padding: "0 8px", minWidth: 28, textAlign: "center" }}>{membershipMenuCount}</span>
                                                                        </span>
                                                                    </div>
                                                                </li>
                                                            )}
                                                            {menuCategories.map((cate, index) => {
                                                                const subs = getSubCategories(cate);
                                                                const hasSubs = subs.length > 0;
                                                                const isExpanded = hasSubs && !menuCollapsed.includes(String(cate.category_id));
                                                                const isFiltered = subFilter && subFilter.categoryId == cate.category_id;
                                                                // the name, count and arrow all expand / collapse the subcategories (or jump to the meal when it has none)
                                                                const toggleMenuCategory = () => {
                                                                    if (hasSubs) {
                                                                        setMenuCollapsed((prev) => isExpanded ? [...prev, String(cate.category_id)] : prev.filter((id) => id !== String(cate.category_id)));
                                                                    } else {
                                                                        handleCategoryClick(cate.category_id);
                                                                    }
                                                                };
                                                                return (
                                                                    <li key={index} className="fs-12 ff-poppins-regular" style={{ borderBottom: "1px solid rgba(255,255,255,0.15)", background: isExpanded ? "rgba(0,0,0,0.22)" : "transparent" }}>
                                                                        <div className="d-flex justify-content-between align-items-center p-1">
                                                                            <button className="dropdown-item d-flex collapsed justify-content-between align-items-center"
                                                                                // inline colours beat Bootstrap's hover / focus / active background (the white block after a tap)
                                                                                style={{ background: "transparent", color: "#fff", boxShadow: "none", outline: "none", textAlign: "left", justifyContent: "flex-start", flex: 1 }}
                                                                                onClick={toggleMenuCategory}  >
                                                                                <span className="truncate-text">{cate?.category_name}</span>
                                                                            </button>
                                                                            <span className="me-1 text-light d-flex align-items-center" role="button" onClick={toggleMenuCategory}>
                                                                                <span style={{ background: "rgba(255,255,255,0.18)", borderRadius: 8, padding: "0 8px", minWidth: 28, textAlign: "center" }}>
                                                                                    {cate?.ticket_count ?? cate?.tickets?.length}
                                                                                </span>
                                                                                {hasSubs && (isExpanded ? <IoIosArrowUp className="ms-2" /> : <IoChevronDown className="ms-2" />)}
                                                                            </span>
                                                                        </div>
                                                                        {isExpanded && (
                                                                            <ul className="list-unstyled m-0 pb-2 px-2">
                                                                                {subs.map((sub) => {
                                                                                    const isSelected = isFiltered && String(subFilter.subId) === String(sub.id);
                                                                                    return (
                                                                                        <li key={sub.id}
                                                                                            role="button"
                                                                                            onClick={() => handleSelectSub(cate.category_id, sub.id)}
                                                                                            className="d-flex justify-content-between align-items-center text-white px-2 py-2 rounded-3"
                                                                                            style={{ background: isSelected ? "rgba(255,255,255,0.2)" : "transparent" }}>
                                                                                            <span className="d-flex align-items-center">
                                                                                                <span style={{ width: 6, height: 6, borderRadius: 3, background: "rgba(222,200,255,0.9)", display: "inline-block", marginRight: 10 }} />
                                                                                                <span className={isSelected ? "ff-poppins-semiBold" : ""}>{sub.name}</span>
                                                                                            </span>
                                                                                            <span style={{ opacity: 0.85 }}>{sub.count}</span>
                                                                                        </li>
                                                                                    );
                                                                                })}
                                                                            </ul>
                                                                        )}
                                                                    </li>
                                                                );
                                                            })}
                                                        </ul>
                                                    </div>
                                                </>
                                            )}
                                        </div>)}

                                    {/* </div>  */}



                                    <div className="accordion margin_bottom_250 ">
                                        {
                                            tickets.length > 0 || allTabList.length > 0 ? (
                                                ticketType == 0 ?
                                                    <div>
                                                        {

                                                            allTabList.length > 0 ?
                                                                visibleAllTabList?.map((list, index) => (
                                                                    <div key={list.category_id} ref={(el) => (categoryRefs.current[list.category_id] = el)} style={{ scrollMarginTop: "120px" }}
                                                                        className={`accordion-item product_list_accordion mt-2 ms-1 me-1 ${openAccordionId == list.category_id ? "open" : ""}`} >
                                                                        <h2 className="accordion-header  rounded-3 primary-bg" id={"collapseOne" + list.category_id}>
                                                                            <button className={`serviceMenu-but  p-2 m-0 accordion-button ff-poppins-bold fs-16 text-white ${isItemOpen(index) ? "" : "collapsed"
                                                                                }`} type="button" onClick={() => toggleAccordion(index)} aria-expanded={isItemOpen(index) ? "true" : "false"}   >
                                                                                <p className="m-0"> {list.category_name} </p>
                                                                                <p className="m-0">
                                                                                    {isItemOpen(index) ? (<IoIosArrowUp style={{ fontSize: 20 }} />) : (<IoChevronDown style={{ fontSize: 20 }} />)}
                                                                                </p>
                                                                                <style>{`button::after { display: none; position: absolute; content: ''; }`}  </style>
                                                                            </button>
                                                                        </h2>
                                                                        <div className={`accordion-collapse collapse ${isItemOpen(index) ? "show" : ""}`} aria-labelledby={"heading" + index}  >
                                                                            {list?.membership_tickets?.length > 0 && (
                                                                                <>
                                                                                    <section>
                                                                                        <div className='alltab-section-header'>
                                                                                            <div className='section-line'></div>
                                                                                            <div className='alltab-section-heading'>Food Memberships</div>
                                                                                            <div className='section-line w-50'></div>
                                                                                        </div>
                                                                                    </section>

                                                                                    <section className="kitchen-combo-section">
                                                                                        <div className="kitchen-combo-grid scroller-style-x">
                                                                                            {list.membership_tickets.map((item) => (
                                                                                                <KitchenMembershiplistCard key={item.ticket_id} item={item} />
                                                                                            ))}
                                                                                        </div>
                                                                                    </section>
                                                                                </>
                                                                            )}


                                                                            {list?.food_tickets?.length > 0 && (
                                                                                <>
                                                                                    <section>
                                                                                        <div className='alltab-section-header '>
                                                                                            <div className='section-line'></div>
                                                                                            <div className='alltab-section-heading'>Food Tickets</div>
                                                                                            <div className='section-line w-50'></div>
                                                                                        </div>
                                                                                    </section>

                                                                                    {list.food_tickets.map((item) => (
                                                                                        <div key={item.ticket_id} data-sub-id={item.ticket_category_id} style={{ margin: "20px 10px" }}>
                                                                                            <KitchenProductTicket
                                                                                                startTime={list?.startTime}
                                                                                                selectDate={paramDate}
                                                                                                item={item}
                                                                                                type={ticketType}
                                                                                                ticketcategory={list}
                                                                                                buynow={'true'}
                                                                                            />
                                                                                        </div>
                                                                                    ))}
                                                                                </>
                                                                            )}


                                                                            {list?.como_tickets?.length > 0 && (
                                                                                <>
                                                                                    <section>
                                                                                        <div className='alltab-section-header '>
                                                                                            <div className='section-line'></div>
                                                                                            <div className='alltab-section-heading'>Combo Tickets</div>
                                                                                            <div className='section-line w-50'></div>
                                                                                        </div>
                                                                                    </section>

                                                                                    <section className="kitchen-combo-section">
                                                                                        <div className="kitchen-combo-grid scroller-style-x">
                                                                                            {list.como_tickets.map((item) => (
                                                                                                <KitchenComboTicket
                                                                                                    key={item.ticket_id}
                                                                                                    startTime={list?.startTime}
                                                                                                    selectDate={paramDate}
                                                                                                    item={item}
                                                                                                    type={ticketType}
                                                                                                    ticketcategory={list}
                                                                                                    buynow={'true'}

                                                                                                />
                                                                                            ))}
                                                                                        </div>
                                                                                    </section>
                                                                                </>
                                                                            )}


                                                                        </div>
                                                                    </div>
                                                                ))
                                                                :
                                                                renderNoTickets()
                                                        }
                                                    </div>
                                                    :
                                                    tickets?.length > 0 ?
                                                        visibleTickets?.map((list, index) => (
                                                            <div key={list.category_id} ref={(el) => (categoryRefs.current[list.category_id] = el)} style={{ scrollMarginTop: "120px" }}
                                                                className={`accordion-item product_list_accordion mt-2 ms-1 me-1 ${openAccordionId == list.category_id ? "open" : ""}`} >
                                                                <h2 className="accordion-header  rounded-3 primary-bg" id={"collapseOne" + list.category_id}>
                                                                    <button className={`serviceMenu-but  p-2 m-0 accordion-button ff-poppins-bold fs-16 text-white ${isItemOpen(index) ? "" : "collapsed"
                                                                        }`} type="button" onClick={() => toggleAccordion(index)} aria-expanded={isItemOpen(index) ? "true" : "false"}   >
                                                                        <p className="m-0"> {list.category_name} </p>
                                                                        <p className="m-0">
                                                                            {isItemOpen(index) ? (<IoIosArrowUp style={{ fontSize: 20 }} />) : (<IoChevronDown style={{ fontSize: 20 }} />)}
                                                                        </p>
                                                                        <style>{`button::after { display: none; position: absolute; content: ''; }`}  </style>
                                                                    </button>
                                                                </h2>
                                                                <div className={`accordion-collapse collapse ${isItemOpen(index) ? "show" : ""}`} aria-labelledby={"heading" + index}  >

                                                                    {ticketType == 1 &&
                                                                        list?.tickets?.map((item) => (
                                                                            <div key={item.ticket_id} data-sub-id={item.ticket_category_id} style={{ margin: "20px 10px" }}>
                                                                                <KitchenProductTicket key={`${ticketType}-${item.id}`}
                                                                                    startTime={list?.startTime} selectDate={paramDate} item={item}
                                                                                    type={ticketType} ticketcategory={list} buynow={'true'} />
                                                                            </div>
                                                                        ))}

                                                                    {ticketType == 2 && (
                                                                        <section className="kitchen-combo-section">
                                                                            <div className="kitchen-combo-grid scroller-style-x">
                                                                                {list?.tickets?.map((item) => (
                                                                                    <KitchenComboTicket key={`${ticketType}-${item.id}`}
                                                                                        startTime={list?.startTime} selectDate={paramDate} item={item}
                                                                                        type={ticketType} ticketcategory={list} buynow={'true'} />
                                                                                ))}
                                                                            </div>
                                                                        </section>
                                                                    )}

                                                                    {ticketType == 3 &&
                                                                        <section className="kitchen-combo-section">
                                                                            <div className="kitchen-combo-grid scroller-style-x">
                                                                                {list?.tickets?.map((list) => (
                                                                                    <KitchenMembershiplistCard key={list.category_id} item={list} />
                                                                                ))}
                                                                            </div>
                                                                        </section>}
                                                                </div>
                                                            </div>
                                                        ))
                                                        :
                                                        renderNoTickets()
                                            ) : (
                                                renderNoTickets()
                                            )
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </> :
                    // skeleton mirrors the real layout: category header bar + ticket cards (image, title, veg/qty, description, price + button)
                    <div className="accordion margin_bottom_250" aria-busy="true" aria-label="Loading tickets">
                        {[1, 2].map((group) => (
                            <div key={group} className="accordion-item product_list_accordion mt-2 ms-1 me-1">
                                <h2 className="accordion-header rounded-3">
                                    <Skeleton height={44} borderRadius={12} />
                                </h2>
                                {[1, 2].map((card) => (
                                    <div key={card} style={{ margin: "20px 10px" }}>
                                        <div className="kitchen-product-card">
                                            <div className="kitchen-product-img-wrapper">
                                                <Skeleton width={100} height={100} borderRadius={12} />
                                            </div>
                                            <div className="kitchen-product-content">
                                                <Skeleton width="65%" height={16} />
                                                <div className="d-flex align-items-center gap-1 mt-1">
                                                    <Skeleton width={14} height={14} />
                                                    <Skeleton width={50} height={12} />
                                                </div>
                                                <Skeleton width="85%" height={12} className="mt-2" />
                                                <div className="d-flex justify-content-between align-items-center mt-2">
                                                    <Skeleton width={55} height={18} />
                                                    <Skeleton width={70} height={26} borderRadius={9999} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ))}
                    </div>
            }
        </div>
    )
}

export default Kitchen_ticket_list

